export default "skymp5-front/45255c99ec0c0f37fbadb45928198869.svg";